import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import LoadingScreen from 'components/LoadingScreen/LoadingScreen.jsx'

import { formatMessage } from 'locale'
import WINDOW_TITLES from 'window_titles'

import requestFortBattleResults from 'state/actions/fort_battle_results'

import { DIRECTIONS, FORT_BATTLE_SERIES_FINISH_REASONS, FORT_BATTLE_SERIES_RESULT } from 'constants'

import {
    BattleList,
    Details,
    Header,
    Subtitle,
    Tabs,
} from './components'

import { POSTBATTLE_TABS_LIST } from './constants.jsx'

import styles from './PostbattleScreen.scss'

export class PostbattleScreen extends React.Component {
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        results: PropTypes.shape({
            direction: PropTypes.oneOf(DIRECTIONS),
            enemy_clan: PropTypes.object,
            own_clan_id: PropTypes.number,
            enemy_clan_id: PropTypes.number,
            result: PropTypes.object,
            rounds: PropTypes.array,
        }),
        requestFortBattleResults: PropTypes.func.isRequired,
    }

    constructor() {
        super()
        this.state = { selectedTab: POSTBATTLE_TABS_LIST[0] }
        this.selectTab = this.selectTab.bind(this)
    }

    componentWillMount() {
        this.props.requestFortBattleResults()
        document.title = formatMessage(WINDOW_TITLES.postbattle)
    }

    selectTab(name) {
        this.setState({ selectedTab: name })
    }

    render() {
        const { loading, results } = this.props

        if (loading) return (
            <div className={styles.base}>
                <LoadingScreen type='window' />
            </div>
        )

        if (!results.result) return null

        const {
            own_clan_id: ownClanId,
            enemy_clan_id: enemyClanId,
            direction,
            enemy_clan: enemyClan,
            rounds,
            result = {},
        } = results
        const { points_under_control: pointsUnderControl, reward } = result

        const outcome = result.is_win ? FORT_BATTLE_SERIES_RESULT.VICTORY :
            (result.is_draw ? FORT_BATTLE_SERIES_RESULT.DRAW : FORT_BATTLE_SERIES_RESULT.DEFEAT)
        const isTimeoutFinish = result.finish_reason === FORT_BATTLE_SERIES_FINISH_REASONS.TIMEOUT

        let resultNode
        let detailsNode
        if (this.state.selectedTab === POSTBATTLE_TABS_LIST[0])
        {
            resultNode = (
                <div>
                    <Header
                        isTimeoutFinish={isTimeoutFinish}
                        outcome={outcome}
                        pointsUnderControl={pointsUnderControl}
                        reward={reward.total}
                    />
                    <Subtitle direction={direction} clan={enemyClan} />
                    <BattleList battles={rounds} ownClanId={ownClanId} enemyClanId={enemyClanId} />
                </div>
            )
        }

        if (this.state.selectedTab === POSTBATTLE_TABS_LIST[1]) {
            detailsNode = (
                <Details pointsUnderControl={pointsUnderControl} reward={reward} rounds={rounds} />
            )
        }

        return (
            <div className={styles.base}>
                <Tabs
                    tabs={POSTBATTLE_TABS_LIST}
                    selected={this.state.selectedTab}
                    handleClick={this.selectTab}
                />
                <div className={styles.tabsContent}>
                    {resultNode}
                    {detailsNode}
                </div>
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    const { loading, results } = state.fortBattleResults
    return { loading, results }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
    const { seriesId, clanId } = ownProps.params
    return {
        requestFortBattleResults: () => dispatch(requestFortBattleResults(seriesId, clanId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostbattleScreen)



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/PostbattleScreen.jsx